import { formatCurrency } from "../../../../utils";

import { BenAdminMappingText } from "./constants";
import { BenAdminOption, TechCreditOption } from "./types";

export const parseTechCreditType = (
  type: string | null,
): TechCreditOption | null => {
  if (!type) {
    return null;
  }
  const lowerType = type.toLowerCase();
  switch (lowerType) {
    case "percentage":
      return "percentage";
    case "dollaramount":
      return "dollarAmount";
    case "pepm":
      return "pepm";
    case "carrierstandard":
      return "carrierStandard";
  }
  return null;
};

export const parseRequestedSystemType = (
  type: string | null,
): BenAdminOption | null => {
  if (!type) {
    return null;
  }
  const lowerType = type.split(" ").join("").toLowerCase();
  switch (lowerType) {
    case "employeenavigator":
      return "employeeNavigator";
    case "ease":
      return "ease";
    case "bswift":
      return "bSwift";
    case "adp":
      return "adp";
    case "plansource":
      return "planSource";
    case "paychex":
      return "paychex";
    case "trinet":
      return "triNet";
    case "rippling":
      return "rippling";
    case "paylocity":
      return "paylocity";
    case "selerix":
      return "selerix";
    case "zenefits":
      return "zenefits";
    case "workday":
      return "workday";
    case "paycom":
      return "paycom";
    case "other":
      return "other";
  }
  return null;
};

export const formatTechCredit = (
  techCreditType: TechCreditOption,
  techCreditAmount: number | null | undefined,
): string => {
  if (techCreditType === "carrierStandard") {
    return "Carrier Standard";
  }
  if (techCreditAmount == null) {
    return "";
  }
  if (techCreditType === "dollarAmount" || techCreditType === "pepm") {
    return `${techCreditType === "dollarAmount" ? "Dollar Amount" : "PEPM"}\n${formatCurrency(techCreditAmount)}`;
  }
  if (techCreditType === "percentage") {
    return `Percentage\n${techCreditAmount}%`;
  }
  return "";
};

export const formatRequestedSystem = (
  requestedSystem: BenAdminOption,
  requestedSystemOther: string | null | undefined,
): string => {
  const lowerRequestedSystem = requestedSystem.toLowerCase();
  if (lowerRequestedSystem === "other") {
    return requestedSystemOther || "Other";
  }
  return BenAdminMappingText[requestedSystem];
};
